export default __webpack_public_path__ + "static/social media 6-4b27e4296b758216169dd8898bc0ab60.webp";